import { X } from 'lucide-react'
import { SHORTCUT_LIST } from '../hooks/useCalendarShortcuts'

interface KeyboardShortcutsOverlayProps {
  open: boolean
  onClose: () => void
}

export function KeyboardShortcutsOverlay({ open, onClose }: KeyboardShortcutsOverlayProps) {
  if (!open) return null

  return (
    <>
      <div className="fixed inset-0 z-50 bg-bg/20" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 z-50 w-[320px] -translate-x-1/2 -translate-y-1/2 rounded-[10px] border bg-bg-2 p-5 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-paper">Keyboard Shortcuts</h3>
          <button onClick={onClose} className="rounded-lg p-1 text-paper-faint hover:bg-bg-3">
            <X size={14} />
          </button>
        </div>
        <div className="space-y-2">
          {SHORTCUT_LIST.map(({ key, description }) => (
            <div key={key} className="flex items-center justify-between">
              <span className="text-sm text-paper-dim">{description}</span>
              <kbd className="rounded border bg-bg-3 px-2 py-0.5 font-mono text-xs text-paper-dim">
                {key}
              </kbd>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
